import * as eventTypes from "./eventTypes";
import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";

const facilityNextStatesReducer = (state = initialState.facilities.facilityNextStates, action) => {
  switch (action.type) {
    case actionTypes.COMPUTE_FACILITY_NEXT_STATES_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };

      return result;
    }

    case actionTypes.COMPUTE_FACILITY_NEXT_STATES_SUCCESS: {
      const { key, payload } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, nextStates: payload };

      return result;
    }

    case actionTypes.COMPUTE_FACILITY_NEXT_STATES_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: false };

      return result;
    }

    case eventTypes.FACILITY_NEXT_STATES_LIST_INVALIDATED: {
      return initialState.facilities.facilityNextStates;
    }

    default:
      return state;
  }
};

export default facilityNextStatesReducer;
